// Common address config
export const GET_ADDRESS_CONFIG = 'common/GET_ADDRESS_CONFIG';

export const ACTIVATE_SHIMMER = 'ACTIVATE_SHIMMER';
export const DEACTIVATE_SHIMMER = 'DEACTIVATE_SHIMMER';

/**
 * clear redux store
 */
export const CLEAR_STORE = 'CLEAR_STORE';
export const DESTROY_USER_STATE_INFO = 'DESTROY_USER_STATE_INFO';
export const DESTROY_USER_FLOW = 'DESTROY_USER_FLOW';
export const DESTROY_DOCUMENT_DATA = 'DESTROY_DOCUMENT_DATA';
export const NON_HARD_MIGRATED_SME_FLOW = 'non_hard_migrated_sme_flow';
export const APPLE_PAY_CONFIG = 'apple_pay_config';

export const STORE_FLAGSMITH_DATA = 'STORE_FLAGSMITH_DATA';
export const STORE_BENE_LIST = 'STORE_BENE_LIST';
/**
 * user session
 */
export const USER_LOGGED_IN_STATE = 'USER_LOGGED_IN_STATE';
export const IS_USER_AUTHENTICATING = 'IS_USER_AUTHENTICATING';
export const IS_USER_AUTHENTICATED = 'IS_USER_AUTHENTICATED';
export const SIGN_UP_NEW_USER_SUCCESS = 'SIGN_UP_NEW_USER_SUCCESS';
export const LOAD_USER_SESSION = 'LOAD_USER_SESSION';
export const TOGGLE_FEATURE_STATE = 'TOGGLE_FEATURE_STATE';
export const GET_NEW_ONBOARDING_ENABLED_USERS = 'GET_NEW_ONBOARDING_ENABLED_USERS';
export const REQUIRED_POA_DOCUMENTS = 'REQUIRED_POA_DOCUMENTS';
export const DOCUMENTS_CONDITIONS = 'DOCUMENTS_CONDITIONS';
export const SET_ATTEMPT_COUNT = 'SET_ATTEMPT_COUNT';
export const SET_INSTAPOINTS_BALANCE = 'SET_INSTAPOINTS_BALANCE';
export const MANUAL_DOCS_INFO = 'MANUAL_DOCS_INFO';
export const SET_USER_ADDRESS = 'SET_USER_ADDRESS';
export const SET_ADDRESS_PAGE_DATA_TOGGLE = 'SET_ADDRESS_PAGE_DATA_TOGGLE';
export const SET_ADDRESS_PAGE_BACK_NAVIGATED = 'SET_ADDRESS_PAGE_BACK_NAVIGATED';
export const UPDATE_USER_TIER = 'UPDATE_USER_TIER';
export const SET_EDITED_RETRIEVED_NAME = 'SET_EDITED_RETRIEVED_NAME';
export const SET_ONBOARDING_EKYC_CMS_DATA = 'SET_ONBOARDING_EKYC_CMS_DATA';
/**
 * user status
 */
export const SET_IS_NEW_USER = 'SET_IS_NEW_USER';
export const LOAD_USER_STATUS = 'LOAD_USER_STATUS';
export const USER_DATA_LOADED = 'USER_DATA_LOADED';

/**
 * mobile verification and otp
 */
export const SET_IS_EU_REGION_MOBILE_VERIFIED = 'SET_IS_EU_REGION_MOBILE_VERIFIED';
export const MOBILE_VERIFICATION_SUBMIT = 'MOBILE_VERIFICATION_SUBMIT';
export const UPDATE_MOBILE_NUMBER = 'UPDATE_MOBILE_NUMBER';
export const LOAD_MOBILE_VALIDATIONS = 'LOAD_MOBILE_VALIDATIONS';

/**
 * existing user -form data to redux
 */
export const USER_STATE_INFO = 'USER_STATE_INFO';

export const SET_INSTAPOINTS_LOGIC_DATA = 'SET_INSTAPOINTS_LOGIC_DATA';

/**
 * form submit, update & delete
 */

export const SAVE_SCREEN_NAME = 'SAVE_SCREEN_NAME';

//SEND MONEY
export const SEND_MONEY_SUBMIT = 'SEND_MONEY_SUBMIT';
export const UPDATE_SEND_MONEY = 'UPDATE_SEND_MONEY';

//PERSONAL DETAILS
export const PERSONAL_DETAILS_SUBMIT = 'PERSONAL_DETAILS_SUBMIT';

//BENEFICIARY DETAILS
export const PAYEE_DETAILS_SUBMIT = 'PERSONAL_DETAILS_SUBMIT';
export const SAVE_BENEFICIARY_ID = 'SAVE_BENEFICIARY_ID';
export const SET_SEND_MONEY_PAYLOAD = 'SET_SEND_MONEY_PAYLOAD';
export const SET_PAYMENT_METHOD_PAYLOAD = 'SET_PAYMENT_METHOD_PAYLOAD';
export const SET_BENE_ADDITIONAL_INFO_VALUE = 'SET_BENE_ADDITIONAL_INFO_VALUE';
export const SET_BENE_ADDRESS_FOR_PAYIN_METHODS = 'SET_BENE_ADDRESS_FOR_PAYIN_METHODS';
/* bank validation */
export const BANK_DETAILS_SUCCESS = 'BANK_DETAILS_SUCCESS';
export const ASYNC_VALIDATION_RESPONSE = 'ASYNC_VALIDATION_RESPONSE';

//APPLICANT
export const APPLICANT_DETAILS_SUBMIT = 'APPLICANT_DETAILS_SUBMIT';
export const APPLICANT_DETAILS_PATCH = 'APPLICANT_DETAILS_PATCH';

//COMPANY ADDRESS
export const COMPANY_ADDRESS_SUBMIT = 'COMPANY_ADDRESS_SUBMIT';

//COMPANY DETAILS
export const COMPANY_DETAILS_SUBMIT = 'COMPANY_DETAILS_SUBMIT';

//ADD AUTHORITY
export const PEOPLE_INFORMATION_KYC_SUBMIT = 'PEOPLE_INFORMATION_KYC_SUBMIT';
export const DELETE_REPRESENTATIVE = 'DELETE_REPRESENTATIVE';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';

//SCHEDULE INTERVIEW
export const GET_USER_ADDRESS = 'GET_USER_ADDRESS';
export const SUBMIT_SCHEDULE_INTERVIEW = 'SUBMIT_SCHEDULE_INTERVIEW';

/**
 * UI triggers
 */
export const ACTIVATE_LOADER = 'ACTIVATE_LOADER';
export const DEACTIVATE_LOADER = 'DEACTIVATE_LOADER';
export const SCROLL_TO_TOP = 'SCROLL_TO_TOP';
export const SCROLL_INTO_VIEW = 'SCROLL_INTO_VIEW';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

/**
 * documents
 */
export const USER_DOCUMENTS_INFO = 'USER_DOCUMENTS_INFO';
export const INSERT_USER_DOCUMENT = 'INSERT_USER_DOCUMENT';
export const DOCS_UPLOADED_OR_EVERIFIED_SUCCESS = 'DOCS_UPLOADED_OR_EVERIFIED_SUCCESS';
export const UPLOAD_DOC_SUCCESS = 'UPLOAD_DOC_SUCCESS';
export const STORE_FROM_VAL_TO_EDIT = 'STORE_FROM_VAL_TO_EDIT ';
export const UPLOAD_PHOTO_SUCCESS = 'UPLOAD_PHOTO_SUCCESS';
export const UPDATE_VISION_CHECK_COUNT = 'UPDATE_VISION_CHECK_COUNT';
export const GET_UPLOAD_DOCUMENTS_CONFIG = 'GET_UPLOAD_DOCUMENTS_CONFIG';
export const E_VERIFY_SUCCESS = 'E_VERIFY_SUCCESS';
export const UPDATE_UPLOAD_DOCUMENTS_CONFIG = 'UPDATE_UPLOAD_DOCUMENTS_CONFIG';

/**
 * user dashboard
 */
export const LOAD_RECENT_TRANSACTIONS_FOR_DASHBOARD = 'LOAD_RECENT_TRANSACTIONS_FOR_DASHBOARD';
export const LOAD_FREQUENT_TRANSACTIONS_FOR_DASHBOARD = 'LOAD_FREQUENT_TRANSACTIONS_FOR_DASHBOARD';
export const SET_BENEFICIARY_DETAILS_FROM_DASHBOARD_TO_QUICKPAY =
  'SET_BENEFICIARY_DETAILS_FROM_DASHBOARD_TO_QUICKPAY';
export const TEMP_CURRENCY_CONVERSION_FIELDS = 'TEMP_CURRENCY_CONVERSION_FIELDS';
export const RESET_TEMP_CURRENCY_CONVERSION_FIELDS = 'RESET_TEMP_CURRENCY_CONVERSION_FIELDS';
export const LOAD_TRANSFER_SUMMARY_FOR_DASHBAORD = 'LOAD_TRANSFER_SUMMARY_FOR_DASHBAORD';
export const STORE_DASHBOARD_CALCULATOR_DATA = 'STORE_DASHBOARD_CALCULATOR_DATA';
export const STORE_IS_NAVIGATED_FROM_DASHBOARD_INIT_TNFER =
  'STORE_IS_NAVIGATED_FROM_DASHBOARD_INIT_TNFER';
export const CLEAR_DASHBOARD_CALCULATOR_DATA = 'CLEAR_DASHBOARD_CALCULATOR_DATA';
/**
 * referral
 */
export const LOAD_REFERRAL_HISTORY = 'LOAD_REFERRAL_HISTORY';

/**
 * subscription and notification
 */
export const SHOW_COMMON_MESSAGE = 'SHOW_COMMON_MESSAGE';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const HIDE_COMMON_MESSAGE = 'HIDE_COMMON_MESSAGE';

/**
 * user registration flow and timeline
 */
export const USER_FLOW_PREV = 'USER_FLOW_PREV';
export const USER_FLOW_NEXT = 'USER_FLOW_NEXT';
export const USER_FLOW_JUMP_TO = 'USER_FLOW_JUMP_TO';
export const USER_FLOW_JUMP_WITH_TIMELINE_CHANGE = 'USER_FLOW_JUMP_WITH_TIMELINE_CHANGE';
export const TIMELINE_FLOW = 'TIMELINE_FLOW';
export const SCREEN_FLOW = 'SCREEN_FLOW';
export const UPDATE_TIMELINE = 'UPDATE_TIMELINE';
export const UPDATE_USER_FLOW = 'UPDATE_USER_FLOW';
export const CHANGE_SCREEN_CONFIG = 'CHANGE_SCREEN_CONFIG';
export const UPDATE_SCREEN_OBJECT = 'UPDATE_SCREEN_OBJECT';
export const UPDATE_TIMELINE_CONFIG = 'UPDATE_TIMELINE_CONFIG';

/**
 * Document internal timeline
 */
export const UPDATE_DOCUMENT_TIMELINE_CONFIG = 'UPDATE_DOCUMENT_TIMELINE_CONFIG';

/**
 * transaction
 */
export const SAVE_TRANSACTION_DETAILS = 'SAVE_TRANSACTION_DETAILS';
export const SAVE_UPSELLING_CMS_POPUP_CONTENTS = 'SAVE_UPSELLING_CMS_POPUP_CONTENTS';
export const RESET_TRANSACTION_DETAILS = 'RESET_TRANSACTION_DETAILS';
export const SAVE_IN_TEMP_CONVERTOR_REDUCER = 'SAVE_IN_TEMP_CONVERTOR_REDUCER';
export const SAVE_TEMP_COUPON_CODE = 'SAVE_TEMP_COUPON_CODE';
export const SET_COUPON_DATA = 'SET_COUPON_DATA';
export const SET_POINTS_DATA = 'SET_POINTS_DATA';
export const SAVE_BENE_DATA = 'SAVE_BENE_DATA';
export const SAVE_SELECTED_BENE_DATA = 'SAVE_SELECTED_BENE_DATA';
export const SAVE_SELECTED_CONFIG_BENE_VALIDATIONS = 'SAVE_SELECTED_CONFIG_BENE_VALIDATIONS';
export const SAVE_SELECTED_SCHEMA_BENE_VALIDATIONS = 'SAVE_SELECTED_SCHEMA_BENE_VALIDATIONS';
export const SAVE_SELECTED_CASHPICK_UP = 'SAVE_SELECTED_CASHPICK_UP';
export const CLEAN_SELECTED_CASHPICK_UP = 'CLEAN_SELECTED_CASHPICK_UP';
export const STORE_CASHPICK_UP_RESPONSE = 'STORE_CASHPICK_UP_RESPONSE';
export const SAVE_TRANSACTION_COMPARISON_DETAILS = 'SAVE_TRANSACTION_COMPARISON_DETAILS';
export const SAVE_COUPON_DATA = 'SAVE_COUPON_DATA';
export const SAVE_NON_FORMATTED_COUPON_DATA = 'SAVE_NON_FORMATTED_COUPON_DATA';
export const SAVE_COUPON_CMS_DATA = 'SAVE_COUPON_CMS_DATA';
export const SAVE_NEW_COUPON_CODE = 'SAVE_NEW_COUPON_CODE';
export const TOGGLE_NEW_COUPON_CODE_APPLIED = 'TOGGLE_NEW_COUPON_CODE_APPLIED';
export const SAVE_NEW_COUPON_AMOUNT = 'SAVE_NEW_COUPON_AMOUNT';
export const SAVE_MIN_SOURCE_AMOUNT_FOR_COUPON = 'SAVE_MIN_SOURCE_AMOUNT_FOR_COUPON';
export const SAVE_PROMOTIONS_CMS_CONTENTS = 'SAVE_PROMOTIONS_CMS_CONTENTS';

/*
 * miscellaneous
 */
export const SWITCH_DEVICE = 'SWITCH_DEVICE';

/*
 * multiple transactions
 */
export const MULTI_TXN_RECIPIENT_LIST = 'MULTI_TXN_RECIPIENT_LIST';
export const MULTI_TXN_CURRENT_BENE = 'MULTI_TXN_CURRENT_BENE';
export const MULTI_TXN_RECIPIENT_LIST_TEMP_ID = 'MULTI_TXN_RECIPIENT_LIST_TEMP_ID';
export const MULTI_TXN_INITIATE_TXN = 'MULTI_TXN_INITIATE_TXN';
export const MULTI_TXN_CLEAR_RECIPIENT = 'MULTI_TXN_CLEAR_RECIPIENT';
export const MULTI_TXN_CLEAR_RECIPIENT_EXCEPT_INITIALISED_TXN =
  'MULTI_TXN_CLEAR_RECIPIENT_EXCEPT_INITIALISED_TXN';

/*
 * Corporate Configuration
 */
export const SET_CORPORATE_CONFIG = 'SET_CORPORATE_CONFIG';

/*
 * Currency Rate
 */
export const GET_CURRENCY_RATE = 'GET_CURRENCY_RATE';

/**
 * User Address Info
 */

export const SET_USER_ADDRESS_INFO = 'SET_USER_ADDRESS_INFO';
export const SET_USER_ADDRESS_ERROR = 'SET_USER_ADDRESS_ERROR';

/**
 * update recipent beased on index
 */
export const UPDATE_RECIPIENT_LIST = 'UPDATE_RECIPIENT_LIST';
export const REPLACE_RECIPIENT_LIST_ITEM = 'REPLACE_RECIPIENT_LIST_ITEM';

/*
 * AU - Green Id store in other details
 */
export const SET_USER_OTHER_DETAILS = 'SET_USER_OTHER_DETAILS';

/**
 * onfido accesstoken
 */
export const STORE_ONFIDO_ACCESS_TOKEN_ERROR = 'STORE_ONFIDO_ACCESS_TOKEN_ERROR';

/**
 * Constant for Search Text
 */
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

/**
 * Constant for Search box Visibility
 */
export const SET_SEARCH_BOX_VISIBILITY = 'SET_SEARCH_BOX_VISIBILITY';
/**
 * Constant for resetting search box details
 */
export const RESET_SEARCHBOX_DETAILS = 'RESET_SEARCHBOX_DETAILS';

export const SET_REQUIRED_DETAILS = 'SET_REQUIRED_DETAILS';

/**
 * onfido accesstoken
 */
export const STORE_ONFIDO_ACCESS_TOKEN = 'STORE_ONFIDO_ACCESS_TOKEN';
export const CLEAR_ONFIDO_TOKEN = 'CLEAR_ONFIDO_TOKEN';
export const SET_DROPDOWN_TEXT_VALUE = 'SET_DROPDOWN_TEXT_VALUE';

/**
 * Visa CArd updated actions
 */
export const CARD_NUMBER_UPDATED = 'CARD_NUMBER_UPDATED';

/**
 * malaysia ekyc
 */

export const EMP_TYPE_PASS = 'EMP_TYPE_PASS';
/**
 * RFI issue fiexd
 */
export const TRANSACTION_KYC_VALUE = 'TRANSACTION_KYC_VALUE';
export const RFI_CMS_VALUE = 'RFI_CMS_VALUE';
export const RFI_LIST = 'RFI_LIST';

/**
 * Personal details fields
 */
export const DISABLE_PERSONAL_DETAILS_FILEDS = 'DISABLE_PERSONAL_DETAILS_FILEDS';

/**
 * csrf token
 */
export const SET_CSRF_TOKEN = 'SET_CSRF_TOKEN';

/**
 * actions constants
 */
export const STORE_PAYMENT_METHOD = 'STORE_PAYMENT_METHOD';
/**
 * actions constants for disabling submit button
 */
export const DISABLE_SUBMIT_BUTTON = 'DISABLE_SUBMIT_BUTTON';
/**
 * CONST FOR SETTING SWIFT CODE
 */
export const SET_BENE_DETAILS = 'SET_BENE_DETAILS';

export const SET_NEW_SIGNUP_USER = 'SET_NEW_SIGNUP_USER';

/**
 * const for setting aadhar encrypted data
 */
export const SET_AADHAR_DETAILS = 'SET_AADHAR_DETAILS';

export const SET_SAVED_AADHAR_DETAILS = 'SET_SAVED_AADHAR_DETAILS';
export const UPDATE_AADHAR_OTP_VERIFICATION_ATTEMPTS = 'UPDATE_AADHAR_OTP_VERIFICATION_ATTEMPTS';

/**
 * India AML Check
 */
export const AML_CHECK_ADDED = 'AML_CHECK_ADDED';
export const SBM_REFERRAL_TRANSACITION_CONSENT_ADDED = 'SBM_REFERRAL_TRANSACITION_CONSENT_ADDED';

//ACK Screen to be Shown Once For New SG

export const ONLY_ACK_SCREEN = 'ONLY_ACK_SCREEN';

//ADD_BENE for send_money bene dropdown list order
export const STORE_RECENT_ADDED_BENE = 'STORE_RECENT_ADDED_BENE';

// FOR PLAID OAUTH
export const SAVE_PLAID_PARAMS = 'SAVE_PLAID_PARAMS';

//for INSTAPOINT
export const ADD_INSTAPOINTS = 'ADD_INSTAPOINT';

//DISABLE ADAM CHAT-BOT
export const DISABLE_CHATBOT = 'DISABLE_CHATBOT';

export const APP_DOWNLOAD_PROMOTION = 'appdownloadpromotion';
export const BLOCKED_RETAIL_SIGNUP_UTM_CAMPAIGNS = 'blocked_retail_signup_utm_campaigns';

/**
 * action constant for toggling helpcenter notification
 */
export const SET_HELPCENTER_NOTIFICATION_DATA = 'SET_HELPCENTER_NOTIFICATION_DATA';
export const TOGGLE_HELPCENTER_NOTIFICATION_STATE = 'TOGGLE_HELPCENTER_NOTIFICATION_STATE';

// App Migration
export const APP_MIGRATION_ENABLED = 'APP_MIGRATION_ENABLED';
export const SHOW_APP_MIGRATION = 'SHOW_APP_MIGRATION';
//pre select payment method
export const PRE_SELECT_PAYMENT_METHOD = 'PRE_SELECT_PAYMENT_METHOD';

export const BUILD_VERSION = 'web_build_version';

//Forex config feature flag
export const FOREX_ALLOWED_PIN_CODES = 'forex_config';
export const NIUM_FOREX_FILE_SIZE_LIMIT = 'nium_forex_file_size_limit';
// New OnBoarding
export const RETRIEVE_USER_INFO = 'RETRIEVE_USER_INFO';

export const CHANGE_CURRENT_SCREEN = 'CHANGE_CURRENT_SCREEN';
export const TOGGLE_MODAL_ERROR = 'TOGGLE_MODAL_ERROR';
export const SAVE_CURRENT_ONBOARDING_VERIFICATION_DOCUMENT =
  'SAVE_CURRENT_ONBOARDING_VERIFICATION_DOCUMENT';
export const COLLECT_POA_TRULIOO = 'COLLECT_POA_TRULIOO';
export const SET_KYC_REVIEW_DATA = 'SET_KYC_REVIEW_DATA';

export const COLLECT_APP_RATING = 'collect_app_rating';

export const COOLING_OFF_PERIOD_ENABLED = 'is_cooling_off_period_feature_enabled';

// NIUM Forex
export const STORE_NIUM_FOREX_USER = 'STORE_NIUM_FOREX_USER';
export const STORE_TRANSACTION_DETAILS = 'STORE_TRANSACTION_DETAILS';
export const STORE_TEMP_TRANSACTION_ID = 'STORE_TEMP_TRANSACTION_ID';
export const STORE_TRANSACTION_ID = 'STORE_TRANSACTION_ID';
export const STORE_SELECTED_BENE_ID = 'STORE_SELECTED_BENE_ID';
export const STORE_IS_PAN_VERIFIED = 'STORE_IS_PAN_VERIFIED';
export const STORE_IS_PAN_NAME_VERIFIED = `STORE_IS_PAN_NAME_VERIFIED`;
export const STORE_RE_VERIFY_AADHAR_FLAG = 'STORE_RE_VERIFY_AADHAR_FLAG';
export const STORE_CAF_DOCUMENT_CHANGED_FLAG = 'STORE_CAF_DOCUMENT_CHANGED_FLAG';
export const STORE_NIUM_FOREX_USER_DETAILS = 'STORE_NIUM_FOREX_USER_DETAILS';
export const STORE_IS_REFERRED = 'STORE_IS_REFERRED';

// help center revamp constants
export const SET_CURRENT_LEVEL_ITEMS = 'SET_CURRENT_LEVEL_ITEMS';
export const SET_CONFIGURATION_DATA = 'SET_CONFIGURATION_DATA';
export const SET_HC_LEVEL_HISTORY = 'SET_HC_LEVEL_HISTORY';
export const POP_FROM_HISTORY = 'POP_FROM_HISTORY';
export const SET_HELP_CENTER_LABELS = 'SET_HELP_CENTER_LABELS';
export const SET_HELP_CENTER_SELECTED_TRANSACTION = 'SET_HELP_CENTER_SELECTED_TRANSACTION';
export const RAISE_NEW_ENQUIRY = 'RAISE_NEW_ENQUIRY';
export const SET_CURRENT_HELP_CENTRE_TICKETS = 'SET_CURRENT_HELP_CENTRE_TICKETS';
export const OPEN_EXISTING_CONVERSATION = 'OPEN_EXISTING_CONVERSATION';
export const SET_ZENDESK_CHATBOT = 'SET_ZENDESK_CHATBOT';
export const RETURN_FROM_RAISE_ENQUIRY = 'RETURN_FROM_RAISE_ENQUIRY';
export const SET_ACTIVE_CHAT_WEB_WIDGET = 'SET_ACTIVE_CHAT_WEB_WIDGET';
export const SET_IS_REVAMP_API_CALLED = 'SET_IS_REVAMP_API_CALLED';
export const HELP_CENTER_UI_LOADING = 'HELP_CENTER_UI_LOADING';
export const ENABLE_ZENDESK_CSAT = 'ENABLE_ZENDESK_CSAT';
export const RESET_HELP_CENTER_LEVELS = 'RESET_HELP_CENTER_LEVELS';
export const TOGGLE_NEW_TRANSACTION_CHAT = 'TOGGLE_NEW_TRANSACTION_CHAT';
export const SET_ACTIVE_CHAT_INFO = 'SET_ACTIVE_CHAT_INFO';
export const SET_PUBLIC_PAGE_LEVEL_VALUE = 'SET_PUBLIC_PAGE_LEVEL_VALUE';
export const SET_USER_TIER = 'SET_USER_TIER';
export const TOGGLE_IS_UTILITY_API_CALLED = 'TOGGLE_IS_UTILITY_API_CALLED';
export const SET_BUSINESS_PAYMENT_METHODS = 'SET_BUSINESS_PAYMENT_METHODS';
export const STORE_NF_CROSS_SELL_INFORMATION = 'STORE_NF_CROSS_SELL_INFORMATION';
export const TOGGLE_IS_NAVIGATED_FROM_DEEPLINK = 'TOGGLE_IS_NAVIGATED_FROM_DEEPLINK';

export const SET_RFI_SG_KYC_SCREEN = 'SET_RFI_SG_KYC_SCREEN';
export const SET_RFI_SG_KYC_DATA = 'SET_RFI_SG_KYC_DATA';

export const STORE_DHA_CHALLAN_DATA = 'STORE_DHA_CHALLAN_DATA';
export const TOGGLE_LOAD_PERSONAL_DATA = 'TOGGLE_LOAD_PERSONAL_DATA';
export const SET_SELECTED_FLOW_TYPE = 'SET_SELECTED_FLOW_TYPE';
export const SET_TEMP_RFI_FORM_VALUES = 'SET_TEMP_RFI_FORM_VALUES';
export const SET_JUMIO_AVAILABILITY = 'SET_JUMIO_AVAILABILITY';
export const CLEAR_RFI_STORE = 'CLEAR_RFI_STORE';
export const SET_SELECTED_ADDRESS_DOCUMENT = 'SET_SELECTED_ADDRESS_DOCUMENT';

// Add beneficiary revamp redux action constants
export const SET_BENE_REVAMP_FORM_VALUES = 'SET_BENE_REVAMP_FORM_VALUES';
export const SET_IS_SELF_BENE = 'SET_IS_SELF_BENE';
export const TOGGLE_REDIRECTED_FROM_SEND_MONEY = 'TOGGLE_REDIRECTED_FROM_SEND_MONEY';
export const RESET_NEW_BENE_FLOW_STATE = 'RESET_NEW_BENE_FLOW_STATE';
export const RESET_FORM_VALUES_STATE = 'RESET_FORM_VALUES_STATE';
export const IS_BENE_SCHEMA_ENABLED = 'IS_BENE_SCHEMA_ENABLED';
export const SET_PAYOUT_API_RESPONSE = 'SET_PAYOUT_API_RESPONSE';
export const SET_SCHEMA_API_RESPONSE = 'SET_SCHEMA_API_RESPONSE';
export const SET_NON_SCHEMA_COUNTRIES_API_RESPONSE = 'SET_NON_SCHEMA_COUNTRIES_API_RESPONSE';
export const SET_RECEIVING_METHOD_BANK_ACCOUNT_COUNTRY_VALUES =
  'SET_RECEIVING_METHOD_BANK_ACCOUNT_COUNTRY_VALUES';

export const PUSH_NAVIGATION_HISTORY = 'PUSH_NAVIGATION_HISTORY';
export const POP_NAVIGATION_HISTORY = 'POP_NAVIGATION_HISTORY';
export const CLEAR_NAVIGATION_HISTORY = 'CLEAR_NAVIGATION_HISTORY';
export const SET_CURRENT_BENE = 'SET_CURRENT_BENE';
export const SET_UNFILTERED_CURRENT_BENE = 'SET_UNFILTERED_CURRENT_BENE';
export const TOGGLE_IS_EDIT_BENE_FLOW = 'TOGGLE_IS_EDIT_BENE_FLOW';
export const SET_SELECTED_COUNTRY_MOBILE_CODE = 'SET_SELECTED_COUNTRY_MOBILE_CODE';
export const SET_POPULAR_COUNTRIES = 'SET_POPULAR_COUNTRIES';
export const SET_ADDRESS_CONFIG = 'SET_ADDRESS_CONFIG';
export const SET_PAYOUT_LABEL = 'SET_PAYOUT_LABEL';
export const SET_BENE_BANK_NAME = 'SET_BENE_BANK_NAME';
export const SET_CURRENT_BENE_ID = 'SET_CURRENT_BENE_ID';
export const SET_CURRENT_FORM_BENE_ADDRESS = 'SET_CURRENT_FORM_BENE_ADDRESS';
export const TOGGLE_SHOULD_PREFILL_BENE_ADDRESS = 'TOGGLE_SHOULD_PREFILL_BENE_ADDRESS';
